module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-ribbon.903d452d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-ribbon.png
// module id = 3146
// module chunks = 11